import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import PaymentMethodForm from "./PaymentMethodForm";
const CreateMethodModal = ({
  isOpenModal,
  onCloseModal,
  fetchPaymentMethodList,
}) => {
  const { t } = useTranslation(["paymentMethod"]);
  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={onCloseModal}
    >
      <ModalHeader toggle={onCloseModal}>{t("title.add")}</ModalHeader>
      <ModalBody>
        <PaymentMethodForm
          mode="CREATE"
          onCancel={onCloseModal}
          fetchPaymentMethodList={fetchPaymentMethodList}
        />
      </ModalBody>
    </Modal>
  );
};

export default CreateMethodModal;
